/* eslint-disable no-empty-pattern */
import Request from '@/services/axios';
import moment from "moment";
let req = new Request;

const fetchCountPlayerOfAffiliate = async ({commit}, data) => {
    const response = await req.get({
        url: 'report/aff_count',
        data
    })
    if (response.data.code) {
        commit('UPDATE_COUNT_PLAYER', response.data.data.count);
    }
};


const fetchAffReport = async ({commit}, date) => {
    commit('UPDATE_LOADING', true);
    const response = await req.get({
        url: 'report/aff_report?year='+date.year+'&month='+(date.month-1),
    })
    if (response.data.code) {
        commit('UPDATE_REPORT_AFF', response.data.data);
    }
    commit('UPDATE_LOADING', false);
};

const fetchBarChart = async ({commit}) => {
    commit('UPDATE_LOADING_BAR', true);// Start date: 12 months ago
    let startDate = moment().subtract(5, 'months');
    // End date: Current month and year
    const endDate = moment();
    
    // Loop through each month until we reach the current month

    while (startDate.isBefore(endDate) || startDate.isSame(endDate, 'month')) {
       
        let selectDate  = {
            month : startDate.format('M'),
            year : startDate.format('YYYY')
        }
        await fetchBarAffReport({commit}, selectDate);
        commit('UPDATE_BAR_CHART_PROGRESS', 16.66);
      
      // Move to the next month
      startDate = startDate.add(1, 'month');
    }
    commit('UPDATE_LOADING_BAR', false);
};

const fetchBarAffReport = async ({commit}, date) =>{
    let response = await req.get({
        url: 'report/aff_report?year='+date.year+'&month='+(date.month-1),
    })
    if (response.data.code) {
        commit('UPDATE_BAR_CHART', response.data.data.total_comission);
    }
 }


export default {
    
    fetchBarChart,
    fetchCountPlayerOfAffiliate,
    fetchAffReport
};
